import { render, staticRenderFns } from "./VideoFrontCard.vue?vue&type=template&id=18f2418a&"
import script from "./VideoFrontCard.vue?vue&type=script&lang=js&"
export * from "./VideoFrontCard.vue?vue&type=script&lang=js&"
import style0 from "./VideoFrontCard.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VCard,VIcon})
